var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({
        backgroundImage: `url(${_vm.isMobile ? _vm.bannerImage.mobile : _vm.bannerImage.desktop})`,
    }),attrs:{"id":"fale-conosco-banner"}},[_c('h1',{attrs:{"id":"fale-conosco-title"}},[_vm._v("Fale Conosco")])])
}
var staticRenderFns = []

export { render, staticRenderFns }